import { create } from "zustand";
import {
  IDefaultEmailTemplate,
  TypeEmailTemplates,
} from "@evennt-tech/api-v2-core";
import { apiV2 } from "api/firebase";
import { registerStore } from "store/utils/reset-store.utils";

type State = {
  defaultEmailTemplates: Array<IDefaultEmailTemplate>;
  isLoading: boolean;
  isLoaded: boolean;
};

type Action = {
  fetch: () => Promise<IDefaultEmailTemplate[]>;
  getByType: (type: TypeEmailTemplates) => IDefaultEmailTemplate | null;
};

export const useDefaultEmailTemplates = create<State & Action>((set, get) => ({
  defaultEmailTemplates: [] as IDefaultEmailTemplate[],
  isLoading: false,
  isLoaded: false,

  getByType: (type: TypeEmailTemplates): IDefaultEmailTemplate | null => {
    const defaultTemplates = get().defaultEmailTemplates.find(
      (template) => template.type === type
    );

    if (!defaultTemplates) return null;

    return defaultTemplates;
  },

  fetch: async () => {
    const {
      isLoaded,
      defaultEmailTemplates: loadedDefaultEmailTemplates,
    } = get();

    if (isLoaded) return loadedDefaultEmailTemplates;

    set(() => ({ isLoading: true }));

    try {
      const defaultEmailTemplates = await apiV2.emailTemplate.default.getAll();

      set(() => ({
        isLoaded: true,
        isLoading: true,
        defaultEmailTemplates,
      }));

      return defaultEmailTemplates;
    } catch {
      set(() => ({ isLoading: false }));
      return [];
    }
  },
}));

registerStore(useDefaultEmailTemplates);
